import { render, staticRenderFns } from "./followBtn.vue?vue&type=template&id=10ee98ee&lang=pug"
import script from "./followBtn.vue?vue&type=script&lang=js"
export * from "./followBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports